// extracted by mini-css-extract-plugin
export default {"loginBanner":"loginBanner_loginBanner__H2xyU"};